/* unplugin-vue-components disabled */import script from "./VideoPlayDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoPlayDialog.vue?vue&type=script&setup=true&lang=js"

import "./VideoPlayDialog.vue?vue&type=style&index=0&id=2c9818aa&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户山农大-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c9818aa"]])

export default __exports__